import { render, staticRenderFns } from "./ItemSku.vue?vue&type=template&id=1c2c14a4&scoped=true&"
import script from "./ItemSku.vue?vue&type=script&lang=js&"
export * from "./ItemSku.vue?vue&type=script&lang=js&"
import style0 from "../style.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./ItemSku.vue?vue&type=style&index=1&id=1c2c14a4&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c2c14a4",
  null
  
)

export default component.exports